
import { Component, Vue, Prop } from "vue-property-decorator"
import { Feature } from "@/types/tenant"

@Component({
	components: {
	}
})
export default class TenantFeatureItem extends Vue {
	@Prop({ required: true })
	feature!: Feature

	@Prop({ default: false })
	enabled!: boolean

	@Prop({ type: Boolean, default: false })
	showBadges!: boolean

	toggleEnabled () {
		this.$emit("setEnabled", !this.enabled)
	}

	showHelp () {
		this.$emit("showHelp", this.feature)
	}
}
